var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-4 pt-4"},[_c('button',{staticClass:"btn btn-info",on:{"click":function($event){return _vm.$store.commit('showModal', 'newProduct')}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" Nouveau produit")])])
}
var staticRenderFns = []

export { render, staticRenderFns }